import { createAsyncThunk } from '@reduxjs/toolkit';
import { Soco } from '~api/soco';
//
export const getAppVersions = createAsyncThunk(
  'app/versions',
  async (params) => {
    const response = await Soco.getAppVersions(params);
    return response.data;
  },
);
